<template>
  <div>
    <v-alert-dialog
      ref="alert"
    >
    </v-alert-dialog>

    <v-dialog
      v-model="dialog"
      max-width="80%"
      persistent
      scrollable
    >
      <v-card>
        <v-card-title>
          Historial de Puestos y Sueldos del Empleado
        </v-card-title>

        <template v-if="loading">
          <v-card-text class="text-center py-8">
            <v-progress-circular
              indeterminate
              size="32"
              width="3"
              class="mb-3"
            ></v-progress-circular>
            <div class="text-subtitle-2">
              Cargando Puestos y Sueldos del Empleado
            </div>
          </v-card-text>
        </template>

        <template v-else>
          <v-card-text class="pt-4 pb-2">
            <div v-if="itemsLocal.length === 0" class="text-center py-8">
              <v-icon size="64" color="grey lighten-1">mdi-briefcase-off-outline</v-icon>
              <p class="text-h6 grey--text text--darken-1 mt-4 mb-2">
                No hay puestos registrados
              </p>
              <p class="grey--text mb-4">
                Comienza agregando el primer puesto del empleado
              </p>
            </div>

            <div v-else class="puestos-timeline">
              <!-- Timeline visual -->
              <div class="mb-4 pa-3 grey lighten-4 rounded">
                <div class="text-caption grey--text text--darken-1 mb-2 font-weight-medium">
                  LÍNEA DE TIEMPO
                </div>

                <div class="timeline-grid">
                  <div
                    v-for="(item, index) in sortedItems"
                    :key="index"
                    class="timeline-item"
                    :style="{ flexGrow: getItemDuration(item) }"
                  >
                    <v-chip
                      small
                      :color="isPastDate(item.fecha_hasta) ? 'grey lighten-1' : 'primary'"
                      :text-color="isPastDate(item.fecha_hasta) ? 'black' : 'white'"
                      class="mb-1"
                    >
                      {{ getPuestoNombre(item.id_puesto) || 'Sin asignar' }}
                    </v-chip>
                    <div class="text-caption">
                      {{ formatDateShort(item.fecha_desde) }} -
                      {{ isPastDate(item.fecha_hasta) ? formatDateShort(item.fecha_hasta) : 'Actual' }}
                    </div>
                  </div>
                </div>
              </div>

              <!-- Lista compacta de puestos como tabla -->
              <v-data-table
                :headers="puestosHeaders"
                :items="itemsLocal"
                dense
                disable-pagination
                hide-default-footer
                class="mb-4"
              >
                <!-- Columna # -->
                <template v-slot:[`item.index`]="{ index, item }">
                  <v-avatar
                    size="26"
                    :color="isPastDate(item.fecha_hasta) ? 'grey lighten-2' : 'primary'"
                    class="white--text"
                  >
                    {{ index + 1 }}
                  </v-avatar>
                </template>

                <!-- Fecha inicio -->
                <template v-slot:[`item.fecha_desde`]="{ item }">
                  <v-datetime-picker
                    class="mt-3"
                    v-model="item.fecha_desde"
                    label=""
                    :not-after="new Date('2050-01-01')"
                  />
                </template>

                <!-- Fecha término -->
                <template v-slot:[`item.fecha_hasta`]="{ item }">
                  <v-datetime-picker
                    class="mt-3"
                    v-model="item.fecha_hasta"
                    label=""
                    :not-after="new Date('2050-01-01')"
                  />
                </template>

                <!-- Puesto -->
                <template v-slot:[`item.puesto`]="{ item }">
                  <v-autocomplete
                    v-model="item.id_puesto"
                    :items="puestos"
                    :loading="loadingPuestos"
                    item-text="nombre"
                    item-value="id_puesto"
                    dense
                    hide-details
                    outlined
                  />
                </template>

                <!-- Sueldo diario -->
                <template v-slot:[`item.sueldo_bruto_quincenal`]="{ item }">
                  <v-text-field
                    v-model="item.sueldo_bruto_quincenal"
                    type="number"
                    dense
                    outlined
                    hide-details
                    prefix="$"
                  />
                </template>

                <!-- Acciones -->
                <template v-slot:[`item.acciones`]="{ index }">
                  <v-btn
                    icon
                    small
                    @click="confirmDelete(index)"
                  >
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </template>
              </v-data-table>


            </div>

            <v-btn
              color="primary"
              outlined
              block
              @click="addRow"
              class="mt-2"
            >
              <v-icon left>mdi-plus-circle</v-icon>
              Agregar nuevo puesto
            </v-btn>
          </v-card-text>

          <v-divider></v-divider>
          <br>

          <v-card-text>
            <v-expansion-panels>
              <v-expansion-panel>
                <v-expansion-panel-header>
                  Historial de Cambios Realizados
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-data-table
                    :items="historics"
                    :headers="historicsHeaders"
                  ></v-data-table>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card-text>

          <v-card-actions class="px-6 py-4">
            <v-spacer></v-spacer>
            <v-btn
              text
              color="green"
              @click="close"
              large
            >
              Cancelar
            </v-btn>
            <v-btn
              text
              color="red"
              :loading="saving"
              :disabled="saving"
              @click="confirm"
            >
              Guardar
            </v-btn>
          </v-card-actions>
        </template>
      </v-card>

      <!-- Diálogo de confirmación para eliminar -->
      <v-dialog v-model="deleteDialog" max-width="400">
        <v-card>
          <v-card-title class="text-h6">
            ¿Eliminar puesto?
          </v-card-title>
          <v-card-text>
            Esta acción no se puede deshacer. ¿Está seguro de que desea eliminar este registro?
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text @click="deleteDialog = false">
              Cancelar
            </v-btn>
            <v-btn color="error" text @click="deleteRow">
              Eliminar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-dialog>
  </div>
</template>

<script>
import VAlertDialog from '@/components/VAlertDialog.vue'
import VDatetimePicker from '@/components/VDatetimePicker.vue'
import moment from 'moment'
import axios from 'axios'

export default {
  name: 'EmpleadoPuestosDialogInline',
  components: {
    VAlertDialog,
    VDatetimePicker
  },
  props: {
    sueldos: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      id_empleado: null,
      dialog: false,
      itemsLocal: [],
      deleteDialog: false,
      indexToDelete: null,
      puestosHeaders: [
        { text: '#',             value: 'index',       sortable: false, align: 'center' },
        { text: 'Fecha inicio',  value: 'fecha_desde', sortable: false },
        { text: 'Fecha término', value: 'fecha_hasta', sortable: false },
        { text: 'Puesto',        value: 'puesto',      sortable: false },
        { text: 'Sueldo Bruto Quincenal', value: 'sueldo_bruto_quincenal',      sortable: false },
        { text: 'Acciones',      value: 'acciones',    sortable: false, align: 'center' }
      ],
      loadingPuestos: false,
      puestos: [],
      loading: false,
      saving: false,
      historics: [],
      loadingHistorics: false,
      historicsHeaders: [
        { text: 'Fecha de Realización', value: 'fecha', sortable: false, align: 'left' },
        { text: 'Usuario', value: 'usuario', sortable: false, align: 'left' },
        { text: 'Cambios Realizados', value: 'mensaje', sortable: false, align: 'left' },

      ],
    }
  },
  computed: {
    sortedItems () {
      return [...this.itemsLocal].sort((a, b) => {
        if (!a.fecha_desde) return 1
        if (!b.fecha_desde) return -1
        return new Date(a.fecha_desde) - new Date(b.fecha_desde)
      })
    }
  },
  methods: {
    getPuestos(){
      this.loadingPuestos = true;
      axios.get('/RecursosHumanos/ListarPuestos')
        .then(r => { this.puestos = r.data; })
        .catch(() => { /* noop */ })
        .finally(() => { this.loadingPuestos = false; })
    },
    addRow () {
      const newItem = {
        id_empleado_puesto: null,
        fecha_desde: null,
        fecha_hasta: null,
        id_puesto: null,
        sueldo_bruto_quincenal: null
      }
      this.itemsLocal.push(newItem)
    },
    confirmDelete (index) {
      this.indexToDelete = index
      this.deleteDialog = true
    },
    deleteRow () {
      if (this.indexToDelete !== null) {
        this.itemsLocal.splice(this.indexToDelete, 1)
        this.indexToDelete = null
      }
      this.deleteDialog = false
    },
    open(id_empleado){
      this.itemsLocal = [];
      this.id_empleado = id_empleado;
      this.dialog = true;
      this.getDetails();
      this.getHistorics();
    },
    close () {
      this.dialog = false;
      this.id_empleado = null;
      this.itemsLocal = [];
    },
    validateItems () {
      if (!this.itemsLocal || this.itemsLocal.length === 0) {
        this.$refs.alert.setMessage('', 'No hay puestos registrados');
        this.$refs.alert.open();
        return false;
      }

      let nullEndDateCount = 0;

      // 1) Validaciones por renglón + contar cuántos tienen fecha_hasta null
      for (let i = 0; i < this.itemsLocal.length; i++) {
        const item = this.itemsLocal[i];

        // Validar puesto asignado
        if (!item.id_puesto) {
          this.$refs.alert.setMessage('', `Falta seleccionar el puesto en el renglón ${i + 1}`);
          this.$refs.alert.open();
          return false;
        }

        // Validar fecha desde
        if (!item.fecha_desde) {
          this.$refs.alert.setMessage('', `Falta la fecha de inicio en el renglón ${i + 1}`);
          this.$refs.alert.open();
          return false;
        }

        // Validar sueldo_bruto_quincenal
        if (this.sueldos && (!item.sueldo_bruto_quincenal || Number(item.sueldo_bruto_quincenal) <= 0)) {
          this.$refs.alert.setMessage('', `Sueldo Bruto Quincenal inválido en el renglón ${i + 1}`);
          this.$refs.alert.open();
          return false;
        }

        // Solo un renglón puede tener fecha_hasta NULL (puesto actual)
        if (!item.fecha_hasta) {
          nullEndDateCount++;

          if (nullEndDateCount > 1) {
          this.$refs.alert.setMessage('', `Más de un renglón no tiene fecha de término. Conflicto en renglón ${i + 1}`);
          this.$refs.alert.open();
            return false;
          }
        } else {
          // Validar que fecha_hasta no sea menor que fecha_desde
          const desde = new Date(item.fecha_desde);
          const hasta = new Date(item.fecha_hasta);

          if (hasta < desde) {
            this.$refs.alert.setMessage('', `La fecha término es menor que la fecha de inicio en el renglón ${i + 1}`);
            this.$refs.alert.open();
            return false;
          }
        }
      }

      // 2) Validar que no se superpongan los periodos
      //    Construimos un arreglo auxiliar con índices y fechas normalizadas
      const periods = this.itemsLocal.map((item, index) => {
        return {
          index, // índice original del renglón
          start: new Date(item.fecha_desde),
          end: item.fecha_hasta ? new Date(item.fecha_hasta) : null
        };
      });

      // Ordenamos por fecha_desde ascendente
      periods.sort((a, b) => a.start - b.start);

      // Recorremos de forma secuencial comparando cada periodo con el siguiente
      for (let i = 0; i < periods.length - 1; i++) {
        const current = periods[i];
        const next = periods[i + 1];

        // Si end es null, significa que es "abierto" (puesto actual) → lo tomamos como infinito
        const currentEnd = current.end ?? new Date(8640000000000000); // Max Date

        // Si currentEnd >= next.start, hay traslape de fechas
        if (currentEnd >= next.start) {
          this.$refs.alert.setMessage('', `Las fechas del renglón ${current.index + 1} se traslapan con el renglón ${next.index + 1}`);
          this.$refs.alert.open();
            
          
          return false;
        }
      }

      // Si pasó todas las validaciones
      return true;
    },
    confirm () {
      if (!this.validateItems()) {
        return;
      }

      this.saving = true;

      axios
      .post(`/RecursosHumanos/ActualizarEmpleadoPuestos/${this.id_empleado}`, this.itemsLocal)
      .then(() => {
        this.close();
        this.$emit("updated");
      })
      .catch(error => {
        if (error.response && error.response.status === 409) {
          const message = error.response.data && error.response.data.msg
            ? error.response.data.msg.replace('Error : ', '')
            : 'No se pudieron actualizar los puestos del empleado.';
          this.$refs.alert.setMessage('', message);
          this.$refs.alert.open();
          return;
        }

        console.log(error);
      })
      .finally(() => {
        this.saving = false;
      })
    },
    getPuestoNombre (idPuesto) {
      const puesto = this.puestos.find(p => p.id_puesto === idPuesto)
      return puesto ? puesto.nombre : ''
    },
    formatDateShort (dateStr) {
      if (!dateStr || dateStr == '') return ''
      const date = new Date(dateStr + 'T00:00:00')
      return date.toLocaleDateString('es-MX', { year: '2-digit', month: 'short' })
    },
    formatPeriodo (desde, hasta) {
      if (!desde) return 'Sin fecha de inicio'
      
      const formatDate = (dateStr) => {
        if (!dateStr) return null
        const date = new Date(dateStr + 'T00:00:00')
        return date.toLocaleDateString('es-MX', { year: 'numeric', month: 'short' })
      }
      
      const desdeFormatted = formatDate(desde)
      const hastaFormatted = hasta ? formatDate(hasta) : 'Actual'
      
      return `${desdeFormatted} - ${hastaFormatted}`
    },
    getItemDuration (item) {
      if (!item.fecha_desde) return 1
      
      const start = new Date(item.fecha_desde)
      const end = item.fecha_hasta ? new Date(item.fecha_hasta) : new Date()
      const months = (end.getFullYear() - start.getFullYear()) * 12 + (end.getMonth() - start.getMonth())
      
      return Math.max(months, 1)
    },
    isPastDate(dateString) {
      if(!dateString || dateString == null) return false;

      const inputDate = moment(dateString, 'YYYY-MM-DD');
      const today = moment().startOf('day'); // Normaliza hora
  
      return inputDate.isSameOrBefore(today, 'day');
    },
    getDetails(){
      this.loading = true;
      axios
      .get(`/RecursosHumanos/ListarEmpleadoPuestos/${this.id_empleado}`)
      .then(response => {
        this.itemsLocal = response.data;
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        this.loading = false;
      })
    },
    getHistorics(){
      this.loadingHistorics = true;
      axios
      .get(`/RecursosHumanos/ListarEmpleadoPuestoCambios/${this.id_empleado}`)
      .then(response => {
        this.historics = response.data;
      })
      .catch(error => {
        console.log(error)
      })
      .finally(() => {
        this.loadingHistorics = false;
      })
    },
  },
  mounted(){
    this.getPuestos();
  }
}
</script>

<style scoped>
.puestos-timeline {
  max-height: 60vh;
  overflow-y: auto;
}

.timeline-container {
  gap: 4px;
  overflow-x: auto;
  padding: 8px 0;
}

.timeline-item {
  min-width: 0; /* permite que el texto no rompa el grid */
  padding: 8px;
  background: white;
  border-radius: 4px;
  text-align: center;
  border: 1px solid #e0e0e0;
}

.timeline-item .v-chip {
  width: 100%;
  justify-content: center;
  font-size: 11px;
  height: 24px;
}

.timeline-grid {
  display: grid;
  grid-template-columns: repeat(6, 1fr); /* 6 por renglón */
  gap: 8px 12px; /* espacio horizontal y vertical */
}

</style>
